import patchAccountableBankingOnboarding from 'api/v2/transactions/patchAccountableBankingOnboarding';
import useMutation from 'hooks/react-query/useMutation';

const useInitiateAccountableBankingOnboarding = () => {
  return useMutation(patchAccountableBankingOnboarding);
};

export default useInitiateAccountableBankingOnboarding;
